import * as React from 'react';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
import { Methodology as MyType } from '@shapeable/kelp-forest-alliance-types';
const gql = String.raw;

export const Methodology: EntityConfig<MyType> = {
  name: 'Methodology',
  label: 'Methodology',
  type: 'taxonomy',
  icon: ({ icons }) => icons.Entities.ImpactResultType,
  autoRoutes: ['list', 'create', 'update'],
  form: {
    fields: {
      ...entityStandardFormFields,
      description: { type: 'longText' },
    }
  }
};
 